// @flow

export type ActionsMap = { [string]: string };
export type Action<T, P> = { type: string, payload: P };

export type ActionCreators = {
  [string]: <T>(payload: T) => { type: string, payload: T },
};

function createAction<T>(action: string): (payload: T) => { type: string, payload: T } {
  return (payload: T) => ({
    type: action,
    payload: payload,
  });
}

function actionCreatorsFactory(actions: ActionsMap): ActionCreators {
  return Object.keys(actions).reduce((acc, action) => {
    const actionName = action.charAt(0).toLowerCase() + action.slice(1);
    return {
      ...acc,
      [actionName]: createAction(actions[action]),
      [action]: createAction(actions[action]),
    };
  }, {});
}

export { createAction, actionCreatorsFactory };
